<div class="container-search-module">
	@if (!loadPage) {
		<lbca-loading class="show z-[1100]" position="relative"></lbca-loading>
	}

	@if (table.body.length === 0 && loadPage) {
		<div
			class="flex flex-col min-h-[124px] mb-[16px] pt-[36px] pb-[32px] pl-[16px] pr-[16px] w-full justify-center items-center min-h-[180px]"
		>
			<div
				class="flex flex-row justify-center items-center bg-gray-50 rounded-lg pt-[8px] pb-[8px] pl-[24px] pr-[24px] shadow-lg"
			>
				<div class="flex flex-col">
					<div class="text-base text-font">Não há nenhum caso a ser vinculado para este caso</div>
				</div>
				<div class="emojis-shackle icon-box ml-[16px]"></div>
			</div>
		</div>
	}

	@if (table.body.length > 0 && loadPage) {
		<div class="mt-[50px] mb-[20px]">
			<lbca-table [table]="table" (clickLine)="clickLine($event)"></lbca-table>
		</div>
	}

	<ng-template #currentStatus let-process>
		@if (process.status === 'open' && process.integrationStatus !== 'sincronizando') {
			<span class="text-base text-gray-600 w-72 h-[22px] flex items-center justify-center">
				Em aberto
			</span>
		}
		@if (process.status === 'open' && process.integrationStatus === 'sincronizando') {
			<span class="text-base text-gray-600 w-72 h-[22px] flex items-center justify-center">
				Sincronizando
			</span>
		}
		@if (process.status === 'finished') {
			<span
				class="bg-primary rounded text-base text-gray-50 w-72 h-[22px] flex items-center justify-center"
			>
				Concluído
			</span>
		}
	</ng-template>
</div>
